module.exports = __webpack_public_path__ + "static/media/depositeQR.af342434.jpg";